import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SectionHeading } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

const WhyChoose = () => {
  const { t } = useLanguage();

  const cards = [
    { icon: "Award", title: t("whyChoose.c1Title"), desc: t("whyChoose.c1Desc") },
    { icon: "Tag", title: t("whyChoose.c2Title"), desc: t("whyChoose.c2Desc") },
    { icon: "Truck", title: t("whyChoose.c3Title"), desc: t("whyChoose.c3Desc") },
    { icon: "Handshake", title: t("whyChoose.c4Title"), desc: t("whyChoose.c4Desc") },
    { icon: "LayoutGrid", title: t("whyChoose.c5Title"), desc: t("whyChoose.c5Desc") },
    { icon: "HeartHandshake", title: t("whyChoose.c6Title"), desc: t("whyChoose.c6Desc") },
    { icon: "Users", title: t("whyChoose.c7Title"), desc: t("whyChoose.c7Desc") },
  ];

  return (
    <section id="why" className="relative py-24 md:py-36 bg-[#f8fff8]" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          eyebrow={t("whyChoose.eyebrow")}
          title={`${t("whyChoose.title")} ${t("whyChoose.titleHighlight")}`}
          subtitle={t("whyChoose.subtitle")}
          testid="why"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {cards.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -6 }}
                className="group relative rounded-3xl bg-white border border-[#95d5b2]/40 p-8 transition-shadow hover:shadow-xl hover:shadow-[#2d6a4f]/8 overflow-hidden"
                data-testid={`why-card-${i}`}
              >
                <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-[#d8f3dc]/60 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative">
                  <div className="h-14 w-14 rounded-2xl bg-[#d8f3dc] flex items-center justify-center text-[#2d6a4f] group-hover:bg-[#40916c] group-hover:text-white transition-colors">
                    <Icon size={24} strokeWidth={1.8} />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-[#222222] mt-6">{item.title}</h3>
                  <p className="font-body text-[15px] text-[#5b6b62] leading-relaxed mt-3">{item.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
